/**
 * CostChip — #77 gold cost badge for credit-consuming action buttons.
 * Generalizes LongevityPage's `.lon-costChip`. Reads the live cost from CreditSpendContext
 * (never hardcoded). Renders inside a button next to its label.
 *
 *   <button onClick={() => spend('ai_recipe', 'Generate recipe?', run)}>
 *     Generate Recipe <CostChip apiType="ai_recipe" />
 *   </button>
 *
 * a11y: the chip is decorative (the button should carry an aria-label if the cost matters to SR
 * users); the gem glyph is aria-hidden. Not a hover-only tooltip.
 */
import React from 'react';
import { useCreditSpend } from '../contexts/CreditSpendContext';

export default function CostChip({ apiType, className = '' }) {
  const { costOf } = useCreditSpend();
  const cost = costOf(apiType);

  // Unknown cost (not loaded yet / not a credited action) → render nothing rather than a wrong value.
  if (cost == null) return null;

  if (cost === 0) {
    return (
      <span className={`cost-chip cost-chip--free ${className}`.trim()} aria-label="Free — no credits">
        Free
      </span>
    );
  }

  return (
    <span
      className={`cost-chip ${cost === 1 ? 'cost-chip--one' : ''} ${className}`.trim()}
      aria-label={`Costs ${cost} credit${cost !== 1 ? 's' : ''}`}
    >
      <span className="cost-chip-gem" aria-hidden="true">⟡</span>{cost}
    </span>
  );
}
